import { Factory } from "@/data/dao/Factory";
import { CookieCache } from "@/data/dao/offline/CookieCache";
import { AuthenticationDao } from "@/data/dao/service/AuthenticationDao";

import { BaseModal } from "@/shared/elements/BaseModal";
import { logError } from "@/shared/logging/errors";

import { i18n } from "@/portal/Trans";

export class SessionExpiredModal extends BaseModal {
    constructor() {
        super(i18n("modal.sessionExpired.title"), "modal-md", false);

        this.$element.addClass("sessionexpired");

        this.$body.append("<p>" + i18n("modal.sessionExpired.text") + "</p>");

        $('<button type="button" class="btn btn-danger">' + i18n("modal.sessionExpired.signinBtn") + "</button>")
            .appendTo(this.$footer!)
            .click((e) => {
                e.preventDefault();

                Factory.getInstance<AuthenticationDao>(AuthenticationDao)
                    .signOut({ keepAllocation: true })
                    .then(() => {
                        location.href = "/";
                    })
                    .catch((ex) => {
                        logError(ex);
                        const cookieStorage = new CookieCache();
                        cookieStorage.remove("tastiersession");
                        location.href = "/";
                    });
            });
    }
}
